'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodashLangClone = require('lodash/lang/clone');

var _lodashLangClone2 = _interopRequireDefault(_lodashLangClone);

var _lodashLangCloneDeep = require('lodash/lang/cloneDeep');

var _lodashLangCloneDeep2 = _interopRequireDefault(_lodashLangCloneDeep);

var _lodashObjectAssign = require('lodash/object/assign');

var _lodashObjectAssign2 = _interopRequireDefault(_lodashObjectAssign);

var _shallowEquals = require('shallow-equals');

var _shallowEquals2 = _interopRequireDefault(_shallowEquals);

var _TranshandDesign = require('./TranshandDesign');

var _TranshandDesign2 = _interopRequireDefault(_TranshandDesign);

var _DefaultCoordinator = require('./DefaultCoordinator');

var _DefaultCoordinator2 = _interopRequireDefault(_DefaultCoordinator);

var _Cursor = require('./Cursor');

var _Cursor2 = _interopRequireDefault(_Cursor);

var _fixCursorStyle = require('./fixCursorStyle');

var _fixCursorStyle2 = _interopRequireDefault(_fixCursorStyle);

var _cursorHintCursorHint = require('./cursorHint/CursorHint');

var _cursorHintCursorHint2 = _interopRequireDefault(_cursorHintCursorHint);

var _utils = require('./utils');

var Transhand = (function (_React$Component) {
  _inherits(Transhand, _React$Component);

  _createClass(Transhand, null, [{
    key: 'propTypes',
    value: {
      transform: _react.PropTypes.shape({
        tx: _react.PropTypes.number.isRequired,
        ty: _react.PropTypes.number.isRequired,
        sx: _react.PropTypes.number.isRequired,
        sy: _react.PropTypes.number.isRequired,
        rz: _react.PropTypes.number.isRequired,
        ox: _react.PropTypes.number.isRequired,
        oy: _react.PropTypes.number.isRequired
      }).isRequired,
      transformTypes: _react.PropTypes.array,
      rect: _react.PropTypes.shape({
        x: _react.PropTypes.number.isRequired,
        y: _react.PropTypes.number.isRequired,
        w: _react.PropTypes.number.isRequired,
        h: _react.PropTypes.number.isRequired
      }),
      rotateFingerDist: _react.PropTypes.number,
      originRadius: _react.PropTypes.number,
      coordinator: _react.PropTypes.shape({
        localToGlobal: _react.PropTypes.func.isRequired,
        globalToLocal: _react.PropTypes.func.isRequired
      }),
      stroke: _react.PropTypes.object,
      DesignComponent: _react2['default'].PropTypes.func,
      hitns: _react2['default'].PropTypes.object,
      CursorHintDesignComponent: _react2['default'].PropTypes.func,
      onChange: _react2['default'].PropTypes.func,
      onClick: _react2['default'].PropTypes.func,
      onStartDrag: _react2['default'].PropTypes.func,
      onEndDrag: _react2['default'].PropTypes.func,
      grabEvent: _react2['default'].PropTypes.any,
      cursor: _react2['default'].PropTypes.object
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      transform: {
        tx: 0, ty: 0,
        sx: 1, sy: 1,
        rz: 0,
        ox: 0.5, oy: 0.5
      },
      rect: {
        x: 0, y: 0, w: 0, h: 0
      },
      transformTypes: ['translate', 'rotate', 'scale', 'origin'],
      rotateFingerDist: 16,
      originRadius: 6,
      coordinator: new _DefaultCoordinator2['default'](),
      stroke: {
        strokeWidth: '1',
        stroke: 'lime'
      },
      DesignComponent: _TranshandDesign2['default'],
      grabEvent: null,
      cursor: new _Cursor2['default'](),
      hints: {
        scaleXY: ['shift - keep shape', 'alt - from the opposite side'],
        scaleXorY: ['alt - from the opposite side'],
        rotate: ['shift - 15° steps'],
        move: ['shift - move in one dimension']
      }
    },
    enumerable: true
  }]);

  function Transhand(props) {
    var _this = this;

    _classCallCheck(this, Transhand);

    _get(Object.getPrototypeOf(Transhand.prototype), 'constructor', this).call(this, props);

    this.handleMouseDown = function (e) {
      if (!_this._finger) {
        return;
      }

      e.stopPropagation();
      e.preventDefault();

      _this._isDraggedSinceDown = false;
      _this._isHandle = true;

      // ReactDOM.findDOMNode(this).style.pointerEvents = 'auto'

      _this._mdPos = {
        m: _this.props.coordinator.globalToLocal({ x: e.clientX, y: e.clientY }),
        transform: (0, _lodashLangCloneDeep2['default'])(_this.props.transform),
        points: (0, _lodashLangCloneDeep2['default'])(_this.state.points),
        pOrigin: (0, _lodashLangClone2['default'])(_this.state.pOrigin)
      };

      window.addEventListener('mouseup', _this.handleMouseUp);
      window.addEventListener('mouseleave', _this.handleMouseUp);
      // window.addEventListener('mousemove', this.handleDrag)

      if (_this.props.onStartDrag) {
        _this.props.onStartDrag();
      }
    };

    this.handleMouseUp = function (e) {
      window.removeEventListener('mouseup', _this.handleMouseUp);
      window.removeEventListener('mouseleave', _this.handleMouseUp);
      // window.removeEventListener('mousemove', this.handleDrag)

      e.stopPropagation();
      e.preventDefault();

      if (_this._rafOnDragRafId) {
        _this.deferredHandleDrag();
      }

      _this._isHandle = false;

      //hack! fix to click behind the handler on releasing it
      // var deRoot = ReactDOM.findDOMNode(this)
      // setTimeout(() => {
      //   deRoot.style.pointerEvents = 'none'
      // })

      if (_this.props.onEndDrag) {
        _this.props.onEndDrag();
      }

      if (!_this._isDraggedSinceDown && _this.props.onClick) {
        _this.props.onClick(e);
      }
    };

    this.handleMouseMove = function (e) {
      _this._isDraggedSinceDown = true;

      if (_this._isHandle) {
        _this._onDragMe = e;

        if (!_this._rafOnDragRafId) {
          _this._rafOnDragRafId = requestAnimationFrame(_this.deferredHandleDrag);
        }
        _this.setHint(null);
      } else /*if (this.state.hoverHitbox)*/{
          _this._finger = _this.getFinger(e);
        }

      var cursor = _this.getCursor(e);
      _this.setState({ cursor: cursor });
    };

    this.deferredHandleDrag = function () {
      var e = _this._onDragMe;
      _this._onDragMe = undefined;

      window.cancelAnimationFrame(_this._rafOnDragRafId);
      _this._rafOnDragRafId = undefined;

      var _props = _this.props;
      var rect = _props.rect;
      var transform = _props.transform;
      var coordinator = _props.coordinator;
      var onChange = _props.onChange;
      var pOrigin = _this.state.pOrigin;

      var md = _this._mdPos;
      var m = coordinator.globalToLocal({ x: e.clientX, y: e.clientY });
      var dx = m.x - md.m.x;
      var dy = m.y - md.m.y;
      var alt = e.altKey;
      var shift = e.shiftKey;
      var change = {};
      var finger = _this._finger;

      if (finger === 'origin') {
        setOrigin();
      }

      if (finger === 'move') {
        setTransform();
      }

      if (finger && finger.charAt(0) === '1') {
        setScale(-Math.PI / 2, 'sy', -1);
      }

      if (finger && finger.charAt(1) === '1') {
        setScale(0, 'sx', 1);
      }

      if (finger && finger.charAt(2) === '1') {
        setScale(Math.PI / 2, 'sy', 1);
      }

      if (finger && finger.charAt(3) === '1') {
        setScale(Math.PI, 'sx', -1);
      }

      if (finger === 'rotate') {
        setRotation();
      }

      if (shift && 'sx' in change && 'sy' in change) {
        fixProportion();
      }

      if (onChange) {
        onChange(change);
      }

      function setScale(r, sN, way) {

        var rad = r + md.transform.rz;
        var mdDist = (0, _utils.distToPointInAngle)(md.pOrigin, md.m, rad);
        var dragDist = (0, _utils.distToPointInAngle)(md.pOrigin, m, rad);
        var scale = dragDist / mdDist * md.transform[sN];

        if (alt) {
          var es = (scale - md.transform[sN]) / 2;
          var tN = 't' + sN.charAt(1);
          var dN = sN.charAt(1) === 'x' ? 'w' : 'h';

          scale -= es;
          change[tN] = transform[tN] = md.transform[tN] + rect[dN] * (es / 2) * way;
        }

        change[sN] = transform[sN] = scale;
      }

      function fixProportion() {

        var mx = m.x - pOrigin.x;
        var my = m.y - pOrigin.y;
        var mr = Math.abs((0, _utils.radDiff)(transform.rz, Math.atan2(my, mx)));
        var isVertical = mr > Math.PI / 4 && mr < Math.PI / 4 * 3;
        var spx = transform.sx / md.transform.sx;
        var spy = transform.sy / md.transform.sy;

        spx *= spx < 0 ? -1 : 1;
        spy *= spy < 0 ? -1 : 1;

        var sp = isVertical ? spy : spx;

        change.sx = transform.sx = md.transform.sx * sp;
        change.sy = transform.sy = md.transform.sy * sp;
      }

      function setRotation() {

        var mdx = md.m.x - pOrigin.x,
            mdy = md.m.y - pOrigin.y,
            mdr = Math.atan2(mdy, mdx),
            mx = m.x - pOrigin.x,
            my = m.y - pOrigin.y,
            mr = Math.atan2(my, mx),
            r = mr - mdr;

        if (shift) {

          r = Math.floor(r / (Math.PI / 12)) * (Math.PI / 12);
        }

        change.rz = transform.rz = md.transform.rz + r;
      }

      function setTransform() {

        if (shift) {

          if (Math.abs(dx) > Math.abs(dy)) {

            change.tx = transform.tx = md.transform.tx + dx;
            change.ty = transform.ty = md.transform.ty;
          } else {
            change.tx = transform.tx = md.transform.tx;
            change.ty = transform.ty = md.transform.ty + dy;
          }
        } else {
          change.tx = transform.tx = md.transform.tx + dx;
          change.ty = transform.ty = md.transform.ty + dy;
        }
      }

      function setOrigin() {

        var mx = m.x - md.pOrigin.x,
            my = m.y - md.pOrigin.y,
            dist = Math.sqrt(Math.pow(mx, 2) + Math.pow(my, 2)),
            r = Math.atan2(my, mx) - transform.rz,
            x = Math.cos(r) * dist / transform.sx,
            y = Math.sin(r) * dist / transform.sy;

        x = parseInt(x * 1000) / 1000; //?hack??
        y = parseInt(y * 1000) / 1000;

        change.ox = transform.ox = md.transform.ox + x / rect.w;
        change.oy = transform.oy = md.transform.oy + y / rect.h;
        change.tx = transform.tx = md.transform.tx + (mx - x);
        change.ty = transform.ty = md.transform.ty + (my - y);
      }
    };

    this.getHitEvents = function () {
      //TODO onFirstMove - handle when transhand appears under the mouse
      return {
        onMouseEnter: function onMouseEnter() {
          return _this.setState({ hoverHitbox: true });
        },
        onMouseLeave: function onMouseLeave() {
          return _this.setState({ hoverHitbox: false });
        },
        onMouseDown: function onMouseDown(e) {
          return _this.handleMouseDown(e);
        }
      };
    };

    this.state = {
      points: [{}, {}, {}, {}],
      pOrigin: {}
    };
  }

  _createClass(Transhand, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.refreshPoints();
      window.addEventListener('mousemove', this.handleMouseMove);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('mousemove', this.handleMouseMove);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.refreshPoints(nextProps);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _state = this.state;
      var points = _state.points;
      var pOrigin = _state.pOrigin;

      return !((0, _shallowEquals2['default'])(this.props, nextProps) && (0, _shallowEquals2['default'])(this.state, nextState) && (0, _shallowEquals2['default'])(this.props.stroke, nextProps.stroke) && (0, _utils.equPoints)(pOrigin, nextState.pOrigin) && (0, _utils.equPoints)(points[0], nextState.points[0]) && (0, _utils.equPoints)(points[1], nextState.points[1]) && (0, _utils.equPoints)(points[2], nextState.points[2]) && (0, _utils.equPoints)(points[3], nextState.points[3]));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var grabEvent = this.props.grabEvent;

      if (grabEvent) {
        this.handleNewGrabEvent(grabEvent);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var grabEvent = this.props.grabEvent;

      if (grabEvent && grabEvent !== prevProps.grabEvent) {
        this.handleNewGrabEvent(grabEvent);
      }
    }
  }, {
    key: 'handleNewGrabEvent',
    value: function handleNewGrabEvent(grabEvent) {
      this._finger = 'move';
      this.handleMouseDown(grabEvent);
    }
  }, {
    key: 'allowed',
    value: function allowed(transformType) {
      return this.props.transformTypes.indexOf(transformType) !== -1;
    }
  }, {
    key: 'refreshPoints',
    value: function refreshPoints(props) {
      props = props || this.props;

      var _props2 = props;
      var rect = _props2.rect;
      var transform = _props2.transform;
      var p = this.state.points.map(function (point) {
        return (0, _lodashLangClone2['default'])(point);
      });
      var po = (0, _lodashLangClone2['default'])(this.state.pOrigin);

      rect = (0, _lodashLangClone2['default'])(rect);

      rect.x += transform.tx;
      rect.y += transform.ty;

      po.x = rect.x + rect.w * transform.ox;
      po.y = rect.y + rect.h * transform.oy;

      var tox = rect.x + transform.ox * rect.w,
          toy = rect.y + transform.oy * rect.h;

      t(p[0], rect.x, rect.y);
      t(p[1], rect.x + rect.w, rect.y);
      t(p[2], rect.x + rect.w, rect.y + rect.h);
      t(p[3], rect.x, rect.y + rect.h);

      this.setState({
        points: p,
        pOrigin: po
      });

      function t(point, x, y) {
        var dx = (x - tox) * transform.sx;
        var dy = (y - toy) * transform.sy;
        var d = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
        var rad = Math.atan2(dy, dx) + transform.rz;
        var nx = Math.cos(rad);
        var ny = Math.sin(rad);
        var rx = d * nx;
        var ry = d * ny;
        var px = tox + rx;
        var py = toy + ry;

        point.x = px;
        point.y = py;
      }
    }
  }, {
    key: 'setHint',
    value: function setHint(name) {
      var hints = this.props.hints;

      this.setState({
        activeHint: hints && hints[name]
      });
    }

    // Event Handlers ////////////////////////////////////////////////////////////

  }, {
    key: 'getFinger',
    value: function getFinger(e) {
      var _props3 = this.props;
      var rect = _props3.rect;
      var transform = _props3.transform;
      var coordinator = _props3.coordinator;
      var originRadius = _props3.originRadius;

      var p = this.state.points;
      var po = this.state.pOrigin;
      var diff = 3;
      var rDiff = 16;
      var m = coordinator.globalToLocal({ x: e.clientX, y: e.clientY });
      var dox = po.x - m.x;
      var doy = po.y - m.y;
      var dOrigin = Math.sqrt(Math.pow(dox, 2) + Math.pow(doy, 2));
      var dTop = (0, _utils.distToSegment)(m, p[0], p[1]);
      var dLeft = (0, _utils.distToSegment)(m, p[1], p[2]);
      var dBottom = (0, _utils.distToSegment)(m, p[2], p[3]);
      var dRight = (0, _utils.distToSegment)(m, p[3], p[0]);
      var top = dTop < diff;
      var left = dLeft < diff;
      var bottom = dBottom < diff;
      var right = dRight < diff;
      var inside = (0, _utils.isInside)(m, p);
      var finger = null;

      if (rect.w * transform.sx < diff * 2 && inside) {
        left = false;
        right = false;
      }

      if (rect.h * transform.sy < diff * 2 && inside) {
        top = false;
        bottom = false;
      }

      if (dOrigin < originRadius) {
        if (this.allowed('origin')) {
          finger = 'origin';
          this.setHint(null);
        }
      } else if (this.allowed('scale') && (top || right || bottom || left)) {
        //TODO its sould be top-right-bottom-left
        finger = (top ? '1' : '0') + (left ? '1' : '0') + (bottom ? '1' : '0') + (right ? '1' : '0');
        if ((finger + finger).indexOf('11') !== -1) {
          this.setHint('scaleXY');
        } else {
          this.setHint('scaleXorY');
        }
      } else if (inside) {
        if (this.allowed('translate')) {
          finger = 'move';
          this.setHint('move');
        }
      } else if (dTop < rDiff || dRight < rDiff || dBottom < rDiff || dLeft < rDiff || dOrigin < rDiff) {
        if (this.allowed('rotate')) {
          finger = 'rotate';
          this.setHint('rotate');
        }
      }

      if (finger === null) {
        this.setHint(null);
      }

      return finger;
    }
  }, {
    key: 'getCursor',
    value: function getCursor(e) {
      return this.props.cursor.getCursor(this.props, (0, _lodashObjectAssign2['default'])({ finger: this._finger }, this.state), e.clientX, e.clientY);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props;
      var DesignComponent = _props4.DesignComponent;
      var CursorHintDesignComponent = _props4.CursorHintDesignComponent;

      var props = _objectWithoutProperties(_props4, ['DesignComponent', 'CursorHintDesignComponent']);

      var _state2 = this.state;
      var cursor = _state2.cursor;
      var points = _state2.points;
      var pOrigin = _state2.pOrigin;
      var activeHint = _state2.activeHint;

      var style = {
        cursor: cursor,
        position: 'fixed',
        pointerEvents: this._isHandle ? 'auto' : 'none',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%'
      };

      return _react2['default'].createElement(
        'div',
        null,
        _react2['default'].createElement(
          'svg',
          {
            style: style,
            ref: 'root',
            onClick: function (e) {
              return e.stopPropagation();
            } },
          _react2['default'].createElement(DesignComponent, _extends({}, props, {
            cursor: cursor,
            points: points,
            pOrigin: pOrigin,
            getHitEvents: this.getHitEvents }))
        ),
        _react2['default'].createElement(_cursorHintCursorHint2['default'], {
          hint: activeHint,
          DesignComponent: CursorHintDesignComponent })
      );
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      (0, _fixCursorStyle2['default'])(this.refs.root, this.state.cursor); //HACK
    }
  }]);

  return Transhand;
})(_react2['default'].Component);

exports['default'] = Transhand;
module.exports = exports['default'];
//# sourceMappingURL=Transhand.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/transhand/lib/Transhand.js
 ** module id = 559
 ** module chunks = 0
 **/